import { useEffect } from "react";
import axios from "axios";
import { API } from "@/apiConfig";
import { applyTheme, DEFAULT_THEME_ID, THEME_EVENT } from "@/themes";

export default function ThemeManager() {
  useEffect(() => {
    const previewTheme = new URLSearchParams(window.location.search).get("themePreview");
    if (previewTheme) {
      applyTheme(previewTheme);
    } else {
      axios.get(`${API}/public/settings`)
        .then(response => applyTheme(response.data?.active_theme || DEFAULT_THEME_ID))
        .catch(() => applyTheme(DEFAULT_THEME_ID));
    }
    const update = event => applyTheme(event.detail || DEFAULT_THEME_ID);
    window.addEventListener(THEME_EVENT, update);
    return () => window.removeEventListener(THEME_EVENT, update);
  }, []);
  return null;
}
